import React, { useContext, useState } from "react";
import { ModalServiceContext, RicosContext } from "./../../../../ricos-context/index.js";
import { getIsModalOpen, useModalState } from "./../../../../ricos-modals/modal-service-provider.js";
import { DropdownButton } from "./../../../../_shared/dropdown-button.js";
import { NODE_ALIGNMENT_BUTTONS } from "./../../../../_shared/node-alignment-dropdown/consts.js";
import { NodeAlignmentDropdown } from "./../../../../_shared/node-alignment-dropdown/node-alignment-dropdown.js";
const NodeAlignmentButton = ({ toolbarItem, dataHook, id }) => {
  const { t, languageDir, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalServiceContext) || {};
  const isModalOpen = useModalState(getIsModalOpen(id));
  const [referenceElement, setReferenceElement] = useState(null);
  const getSelectedAlignment = () => toolbarItem?.attributes.nodeAlignment || (languageDir === "rtl" ? "RIGHT" : "LEFT");
  const onClick = () => {
    modalService.isModalOpen(id) ? modalService.closeModal(id) : modalService.openModal({
      id,
      Component: NodeAlignmentDropdown,
      componentProps: {
        modalId: id,
        getSelectedAlignment,
        getSelectedTextWrap: () => toolbarItem?.attributes.nodeTextWrap ?? true,
        onClick: (alignment) => {
          toolbarItem.commands?.setAlignment({ value: alignment });
          modalService.closeModal(id);
        },
        onTextWrapToggle: () => toolbarItem.commands?.toggleTextWrap(),
        isTextWrapDisabled: () => !toolbarItem.commands?.canToggleTextWrap()
      },
      layout: isMobile ? "drawer" : "floating",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: isModalOpen,
      onClick,
      ref: setReferenceElement,
      icon: NODE_ALIGNMENT_BUTTONS[getSelectedAlignment()].icon,
      tooltip: t("TextAlignmentButton_Tooltip"),
      tabIndex: toolbarItem.presentation.tabIndex
    }
  );
};
var NodeAlignmentButton_default = NodeAlignmentButton;
export {
  NodeAlignmentButton_default as default
};
//# sourceMappingURL=NodeAlignmentButton.js.map
